import { createAction, props } from '@ngrx/store';

export enum Actions {
    Init = '[Theme] Init',
    SelectTheme = '[Theme] Theme Selected',
    SelectThemeFailure = '[Theme] Theme Selection Failure',
    SelectThemeSuccess = '[Theme] Theme Selection Success',
}

export const ThemeActions = {

    init: createAction(Actions.Init),
    selectTheme: createAction(Actions.SelectTheme, props<{ theme: string }>()),
    selectThemeFailure: createAction(Actions.SelectThemeFailure, props<{ error: any }>()),
    selectThemeSuccess: createAction(Actions.SelectThemeSuccess, props<{ theme: string }>()),
};

export const AsyncActions = {
    loadActions: [
        ThemeActions.selectTheme,
    ],
    successActions: [
        ThemeActions.selectThemeSuccess,
    ],
    errorActions: [
        ThemeActions.selectThemeFailure,
    ]
};
